import type { FC } from 'react';

import { Text } from '@/core/tamagoshi/Text/Text';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';

import styles from './styles.module.scss';

export const Title: FC = () => {
  const { title } = useDetail();
  return (
    <Text type="body1" weight="bold" tag="h1" className={styles.title}>
      {title}
    </Text>
  );
};
